import { createSlice } from "@reduxjs/toolkit";
import { baseURL } from "../config";

// config.js (REACT_APP_BASE_URL) is the SINGLE source of the default API base.
//
// This file used to hardcode `https://dev.phyfarm.com` as the default. That server
// is dismantled, so any fresh profile (empty localStorage) silently pointed every
// request at a dead host until someone hand-edited localStorage. The env file is
// now the only default; `environmentSuccess` still overrides it at runtime and
// persists the choice, so the environment switcher behaves exactly as before.

const readStoredEnvironment = () => {
    const stored = localStorage.getItem('environment');
    if (!stored) return null;

    // Current values are written as plain strings by `environmentSuccess`; older
    // builds JSON.stringify'd them. Accept both, reject anything that isn't a
    // usable URL string (e.g. a stale `{}`) so it falls back to the config default.
    try {
        const parsed = JSON.parse(stored);
        return typeof parsed === 'string' && parsed ? parsed : null;
    } catch (error) {
        return stored;
    }
};

const INITIAL_ENVIRONMENT = readStoredEnvironment() || baseURL;

if (!INITIAL_ENVIRONMENT) {
    // Misconfiguration, not a runtime state: no env file and no stored override.
    console.error(
        '[environment] REACT_APP_BASE_URL is not set and no stored environment exists — API calls will fail. Set it in .env.local (local) or .env.development / .env.production.'
    );
}

const environmentSlice = createSlice({
    name: 'environment',
    initialState: {
        environment: INITIAL_ENVIRONMENT,
    },
    reducers: {
        environmentSuccess: (state, action) => {
            localStorage.setItem('environment', action.payload);
            state.environment = action.payload;
        },
        clearEnvironment: (state) => {
            // Drop the override and fall back to the configured default.
            localStorage.removeItem('environment');
            state.environment = baseURL;
        },
    }
});

export default environmentSlice.reducer;

export const { environmentSuccess, clearEnvironment } = environmentSlice.actions;
